import React from 'react';
import './Card.css';
import Text from '../Text/Text';
import CaretDownIcon from '../../assets/Icons/CaretDownIcon.svg?react';
import classNames from 'classnames';
import Collapse from 'rc-collapse';
import motion from '../../utils/motionUtil.ts';

type Props = React.PropsWithChildren<{ title: string }>;

const Card = React.memo(({ children, title }: Props) => {
  const expandIcon = ({ isActive }: any) => {
    return (
      <i
        className={classNames('Card__toggler', {
          'Card__toggler--active': isActive,
        })}
      >
        <CaretDownIcon />
      </i>
    );
  };

  const items = [
    {
      label: (
        <Text bold size={1}>
          {title}
        </Text>
      ),
      children: children,
    },
  ];

  return (
    <Collapse
      className="Card"
      items={items}
      expandIcon={expandIcon}
      openMotion={motion}
      defaultActiveKey={0}
    />
  );
});

export default Card;
